import { render, staticRenderFns } from "./WishesSampleCreate.vue?vue&type=template&id=3a776d26&scoped=true"
import script from "./WishesSampleCreate.vue?vue&type=script&lang=js"
export * from "./WishesSampleCreate.vue?vue&type=script&lang=js"
import style0 from "./WishesSampleCreate.vue?vue&type=style&index=0&id=3a776d26&lang=css"
import style1 from "./WishesSampleCreate.vue?vue&type=style&index=1&id=3a776d26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a776d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a776d26')) {
      api.createRecord('3a776d26', component.options)
    } else {
      api.reload('3a776d26', component.options)
    }
    module.hot.accept("./WishesSampleCreate.vue?vue&type=template&id=3a776d26&scoped=true", function () {
      api.rerender('3a776d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/WishesSampleCreate.vue"
export default component.exports